import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Listing = styled.div `
  ${baseGrid};
  grid-template-columns: 1fr;
  row-gap: ${fluid(30, 32)};

  @media ${from(Device.MobileLarge)} {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 16px;
  }

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const SearchInput = styled.input ``;
export const ArticleListingStyles = {
    Container,
    Listing,
    SearchInput,
};
